import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import ErrorBoundary from './components/common/ErrorBoundary';

// Suppress ResizeObserver loop errors (benign browser issue)
// This is a known issue with ResizeObserver and doesn't affect functionality
// See: https://github.com/WICG/resize-observer/issues/38

// Store original error
const originalConsoleError = console.error;

// Override console.error to filter ResizeObserver errors
console.error = function (...args: any[]) {
  const firstArg = args[0];

  // Check if this is a ResizeObserver error
  if (
    typeof firstArg === 'string' &&
    firstArg.includes('ResizeObserver loop')
  ) {
    // Silently ignore this error
    return;
  }

  // Check if error object contains ResizeObserver message
  if (
    firstArg instanceof Error &&
    firstArg.message?.includes('ResizeObserver loop')
  ) {
    return;
  }

  // Pass all other errors through
  originalConsoleError.apply(console, args);
};

// Catch ResizeObserver errors at the window level
window.addEventListener('error', (event) => {
  if (event.message?.includes('ResizeObserver loop')) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
});

// Catch unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason?.message?.includes('ResizeObserver loop')) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
  // Log plain-object rejections with useful output (avoids "[object Object]" in console)
  if (event.reason && typeof event.reason === 'object' && !(event.reason instanceof Error)) {
    console.error('Unhandled rejection (non-Error):', event.reason);
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  // Note: StrictMode temporarily disabled due to known incompatibility with react-beautiful-dnd
  // See: https://github.com/atlassian/react-beautiful-dnd/issues/2350
  // <React.StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ErrorBoundary>
  // </React.StrictMode>
);